import moment from "moment";

const specialDays = {
  "25-12": "🎄",
  "14-02": "💘",
  "31-10": "🎃",
};

const Dish = () => {
  const url = window.location.href;

  var regex = /[?&]([^=#]+)=([^&#]*)/g,
    params = {},
    match;
  while ((match = regex.exec(url))) {
    params[match[1]] = match[2];
  }

  const safeYear = params.date.split("-")[0];
  let safeMonth = params.date.split("-")[1];
  if (safeMonth.length === 1) {
    safeMonth = "0" + safeMonth;
  }

  const startOfMonth = moment(safeYear + "-" + safeMonth + "-01").startOf(
    "month"
  );

  const colocs = params.colocs
    .split(";")
    .sort()
    .map((c) => decodeURIComponent(c));

  return (
    <div>
      <u>
        <b>Un</b>
      </u>{" "}
      lave vaisselle{" "}
      <b>
        <u>vidé</u>
      </b>{" "}
      rapporte{" "}
      <u>
        <b>deux</b>
      </u>{" "}
      points : deux croix si vidé solo ou une croix chacun si vidé à deux.
      <br />
      Une fois le lave vaisselle vidé, remplissez le avec la vaisselle qui
      traîne (ça ne rapporte pas de point).
      <br />
      <br />
      {startOfMonth.format("MMMM YYYY").toUpperCase()}
      <br />
      <br />
      <table>
        <tbody>
          <tr>
            <td></td>
            {colocs.map((c) => {
              return (
                <td colSpan="2" style={{ borderRight: "3px solid black" }}>
                  {c.toLowerCase()[0].toUpperCase() +
                    c.toLowerCase().substring(1)}
                </td>
              );
            })}
          </tr>
          {new Array(parseInt(startOfMonth.clone().endOf("month").format("DD")))
            .fill(1)
            .map((_, index) => {
              const today = startOfMonth.clone().add(index, "day");
              const dayNumber = today.isoWeekday();
              const isSaturday = dayNumber === 6;
              const isSunday = dayNumber === 7;
              return (
                <tr
                  key={"day_" + index}
                  style={{
                    borderTop: isSaturday ? "3px solid" : "",
                    borderBottom: isSunday ? "3px solid" : "",
                  }}
                >
                  <td>
                    {specialDays[today.format("DD-MM")] || today.format("D")}
                  </td>
                  {colocs.map((_) => {
                    return (
                      <>
                        <td></td>
                        <td style={{ borderRight: "3px solid black" }}></td>
                      </>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default Dish;
